import React from 'react';

export default function About({ name }) {
  return (
    <div className="App">
      <div>
        <title>BEN VEGEL - CONTACT PAGE</title>
        <meta name="description" content="Previous web application versions featured contact page for website feedback and inquiries that helped to improve Privacy." />

        <div class = "wrapper">
          <h1>CONTACT PAGE</h1>
          <p>Previous web application versions featured contact page for website feedback and inquiries that helped to improve Privacy.</p>

          <div class = "video-zaviti">
            <div class = "zaviti-urejeno-video">
              <iframe width="100%" height="100%" src="https://www.youtube.com/embed/vJFQwu6iXYE" title = "ALPINE TWILIGHT ADVENTURE"frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>

          <p>Web browsers and mobile applications have offered features known as Do-Not-Track (DNT) and settings to signal privacy preferences from online browsing experiences. The current web application and previous web application versions indicated no specific response to DNT browser signals. Third-party websites connected to the web application may have extended special case scenarios for cookies and other tracking technologies like web beacons. Time duration for information saved from the current web application had been regularly reduced after initial snapshots taken during calendar year 2024.</p>
        </div>
      </div>
    </div>
  );
}
